import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentTraverseNodeType, isLocationItemField, traverseEntity, } from '@dossierhq/core';
import { MapContainer } from '@dossierhq/leaflet';
import { useCallback } from 'react';
import { SearchEntityStateActions, } from '../../reducers/SearchEntityReducer/SearchEntityReducer.js';
//TODO make configurable through a context. also max bounds
const defaultCenter = { lat: 55.60498, lng: 13.003822 };
export function EntityMap({ className, schema, center, resetSignal, searchEntityState, dispatchSearchEntityState, filterEntity, renderEntityMarker, children, }) {
    const { entities } = searchEntityState;
    const handleBoundingBoxChange = useCallback((boundingBox) => dispatchSearchEntityState(new SearchEntityStateActions.SetQuery({ boundingBox }, { partial: true, resetPagingIfModifying: true })), [dispatchSearchEntityState]);
    return (_jsxs(MapContainer, { className: className, center: center ?? defaultCenter, resetSignal: resetSignal, onBoundingBoxChanged: handleBoundingBoxChange, children: [_jsx(MapContainer.LocateControl, {}), schema && entities
                ? entities.map((entityResult) => {
                    if (entityResult.isError()) {
                        return null;
                    }
                    const entity = entityResult.value;
                    if (filterEntity && !filterEntity(entity)) {
                        return null;
                    }
                    const locations = extractEntityLocations(schema, entity);
                    return locations.map((location, locationIndex) => renderEntityMarker(`${entity.id}-${locationIndex}`, entity, location));
                })
                : null, children] }));
}
function extractEntityLocations(schema, entity) {
    const locations = [];
    for (const node of traverseEntity(schema, ['entity'], entity)) {
        if (node.type === ContentTraverseNodeType.fieldItem) {
            if (isLocationItemField(node.fieldSpec, node.value) && node.value) {
                locations.push(node.value);
            }
        }
    }
    return locations;
}
//# sourceMappingURL=EntityMap.js.map